export enum TabsItemGroup {
    INTERNAL_USER = "INTERNAL_USER",
    EXTERNAL_USER = "EXTERNAL_USER",
}